import { useDoLogoutMutation, useHasProfilePicQuery, useUpdateIsSlackInitiallyConnectedByUserMutation, } from '../generated/graphql-types';
export const useHasProfilePic = (shouldSkip, userId) => {
    const { data, error, loading } = useHasProfilePicQuery({
        skip: shouldSkip,
        variables: {
            userId,
        },
    });
    return {
        error,
        loading,
        data: data?.hasProfilePic,
    };
};
export const useDoLogout = () => {
    const [doLogout, { data, error, loading }] = useDoLogoutMutation();
    return {
        data: data?.Session__doLogout,
        error,
        loading,
        doLogout: () => doLogout({}),
    };
};
export const useupdateIsSlackInitiallyConnectedByUser = (isSlackInitiallyConnectedByUser) => {
    const [updateIsSlackInitiallyConnectedByUserMutation, { data, loading, error },] = useUpdateIsSlackInitiallyConnectedByUserMutation({
        variables: {
            isSlackInitiallyConnectedByUser,
        },
    });
    return {
        data: data?.Session__updateIsSlackInitiallyConnectedByUser,
        error,
        loading,
        updateIsSlackInitiallyConnected: () => updateIsSlackInitiallyConnectedByUserMutation(),
    };
};
//# sourceMappingURL=user-service.js.map